import {
  BusinessOutlined,
  PeopleOutlined,
  StorageRounded,
  VpnKeyOutlined,
} from "@mui/icons-material";
import { EFFECTIVE_ACCESS_PAGE_KEY } from "common/Constants/EffectiveAccess.constants";
import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";

/** Platform admin — panels render on / (same as old CustomTabs; URL does not change between panels). */
export const PLATFORM_SIDE_NAV_ITEMS = [
  {
    id: "customers",
    label: "Customers",
    Icon: BusinessOutlined,
    path: "/customers",
    matchPaths: ["/", "/home", "/customers"],
    pageKey: EFFECTIVE_ACCESS_PAGE_KEY.CUSTOMER,
    subPages: [],
  },
  {
    id: "user-access",
    label: "User access",
    Icon: VpnKeyOutlined,
    path: "/user-access",
    matchPaths: ["/", "/home", "/user-access"],
    pageKey: EFFECTIVE_ACCESS_PAGE_KEY.USER_ACCESS_CONTROL,
    subPages: [],
  },
];

/** Customer admin — permission-gated. Uses /data-management/* and /user-management routes. */
export const ADMIN_SIDE_NAV_ITEMS = [
  {
    id: "data-management",
    label: "Data management",
    Icon: StorageRounded,
    path: INFRAMARK_CONSTANTS.navigationRoutes.edge,
    pageKey: EFFECTIVE_ACCESS_PAGE_KEY.DATA_MANAGEMENT,
    subPages: [
      {
        id: "edge-hierarchy",
        label: "Edge hierarchy",
        path: INFRAMARK_CONSTANTS.navigationRoutes.edge,
        subKey: "edgeHierarchy",
        pageKey: EFFECTIVE_ACCESS_PAGE_KEY.DATA_MANAGEMENT,
      },
      {
        id: "cloud-hierarchy",
        label: "Context hierarchy",
        path: INFRAMARK_CONSTANTS.navigationRoutes.cloud,
        subKey: "cloudHierarchy",
        pageKey: EFFECTIVE_ACCESS_PAGE_KEY.DATA_MANAGEMENT,
      },
      {
        id: "tags",
        label: "Node list",
        path: INFRAMARK_CONSTANTS.navigationRoutes.tags,
        subKey: "tags",
        pageKey: EFFECTIVE_ACCESS_PAGE_KEY.DATA_MANAGEMENT,
      },
      {
        id: "imports",
        label: "Imports",
        path: INFRAMARK_CONSTANTS.navigationRoutes.import,
        subKey: "imports",
        pageKey: EFFECTIVE_ACCESS_PAGE_KEY.DATA_MANAGEMENT,
      },
    ],
  },
  {
    id: "user-management",
    label: "User management",
    Icon: PeopleOutlined,
    path: INFRAMARK_CONSTANTS.navigationRoutes.userManagement,
    pageKey: EFFECTIVE_ACCESS_PAGE_KEY.USER_MANAGEMENT,
    subPages: [],
  },
];

export const ALL_SIDE_NAV_ITEMS = [
  ...PLATFORM_SIDE_NAV_ITEMS,
  ...ADMIN_SIDE_NAV_ITEMS,
];

export const SIDE_NAV_PATH_ALIASES = {};
